import LabServiceCollection from "@/collections/LabServiceCollection";
import TestPackageAnalyteModel from "../../models/lab/TestPackageAnalyteModel";

/**
 * TestPackageAnalyte collection
 */
export default class TestPackageAnalyteCollection extends LabServiceCollection {

  // Model that is contained in this collection.
  model() {
    return TestPackageAnalyteModel;
  }

}
